import type { Phase, ProcessProgress } from "../../state.js";

interface ProgressBarProps {
  phase: Phase;
  progress: ProcessProgress | null;
  onCancel: () => void;
}

export function ProgressBar({ phase, progress, onCancel }: ProgressBarProps) {
  if (phase !== "processing" || !progress) return null;
  const { current, total } = progress;
  const pct = total === 0 ? 0 : Math.round((current / total) * 100);
  return (
    <div className="progress">
      <div className="progress-line">
        <span>Processing {current} / {total} outputs… ({pct}%)</span>
        <button className="danger" onClick={onCancel}>取消</button>
      </div>
      <div className="progress-bar-bg">
        <div className="progress-bar-fill" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
